import * as React from 'react';
import { useRecoilValue } from 'recoil';
import { AEventTypes } from '../../../../atoms/global/events';
import Dropdown from '../../../../components_v2/dropdown/Dropdown';
import { setLocalStorage } from '../../../../helpers/localStorage';
import { Translate, translateToString } from '../../../../styles/global/translate';
import { getImageFromEventTypeName } from '../../../client-companies/Companies';
import { FlexDiv } from '../../../products/style';
import { BoolSlider } from '../../../settings/subSettings/CalculatedFieldsCreation';
import { ConstraintType, ModalCalendarH4, ModalCalendarP, ModalCalendarSettingsDescriptionAndDropdown, OPTIMIZATION_RIGHT_PANEL_WIDTH_WITHOUT_PADDING } from '../ModalCalendar';
import { ConstraintProps } from './constraints';

const key = 'PlanifiedEvents';
type Key = typeof key;

export default function PlanifiedEventsConstraint(props: ConstraintProps) {
	const eventTypes = useRecoilValue(AEventTypes);
	const [constraints, setConstraints] = props.constraintsHook;
	const settings = constraints.get(key) as ConstraintType[Key]['settings'];
	const defaultConstraint = props.defaultConstraints[key];

	return <>
		<ModalCalendarH4>{defaultConstraint.label}</ModalCalendarH4>
		<ModalCalendarSettingsDescriptionAndDropdown>
			<ModalCalendarP><Translate id='planned_events_description' /></ModalCalendarP>
			<Dropdown
				isMulti
				dropdownStyle={{
					optionWidth: `${OPTIMIZATION_RIGHT_PANEL_WIDTH_WITHOUT_PADDING}px`,
					optionHeight: '260px',
					width: '100%',
					containerWidth: '100%',
					optionBlockHeight: '34px'
				}}
				checkbox
				checkboxAll
				doNotDeleteOptionOnSelect
				datalist={eventTypes.map(et => ({
					value: et,
					label: translateToString(`event.${et.name}`),
					imageJsx: getImageFromEventTypeName(et.name),
					checked: settings?.events.has(et.id) ?? false
				}))}
				name={'event_type_dropdown'}
				onChange={values => setConstraints(c => {
					const lst = values.map(v => v.value.id);
					setLocalStorage(key + '_events', lst);
					c.set(key, { ...settings, events: new Set(lst) });
					return new Map(c);
				})}
			/>
		</ModalCalendarSettingsDescriptionAndDropdown>
		<FlexDiv gap='8px' width='100%'>
			<BoolSlider isActive={settings.allowOvertime} onClick={() => setConstraints(c => {
				settings.allowOvertime = !settings.allowOvertime;
				setLocalStorage(key + '_allowOvertime', settings.allowOvertime);
				return new Map(c);
			})} />
			<ModalCalendarP><Translate id='allow_overtime' /></ModalCalendarP>
		</FlexDiv>
	</>;
}
